"use client";

import { useIsEmbed } from "@calcom/embed-core/embed-iframe";
import { withBookingLanguage } from "@calcom/lib/bookingLanguages";
import { useLocale } from "@calcom/lib/hooks/useLocale";
import { Button } from "@calcom/ui/components/button";
import { useBookingLanguage } from "@calcom/web/modules/booking-language/BookingLanguageProvider";
import { usePathname } from "next/navigation";

/** Links from a booking page to the page that lists its services, one path segment up. Uses the app router, so the platform Booker must not render it. */
export function BackToServicesLink() {
  const isEmbed = useIsEmbed();
  const pathname = usePathname();
  const bookingLanguage = useBookingLanguage();
  const { t } = useLocale();

  const segments = pathname?.split("/").filter(Boolean) ?? [];
  if (isEmbed || segments.length < 2) return null;

  const servicesPath = `/${segments.slice(0, -1).join("/")}`;
  return (
    <Button
      href={bookingLanguage ? withBookingLanguage(servicesPath, bookingLanguage.locale) : servicesPath}
      color="minimal"
      variant="icon"
      StartIcon="arrow-left"
      aria-label={t("back")}
      tooltip={t("all_services")}
      data-testid="back-to-services"
      className="-ml-2 shrink-0"
    />
  );
}
